import { render, staticRenderFns } from "./factory_item_serviceArea.vue?vue&type=template&id=670c1047"
import script from "./factory_item_serviceArea.vue?vue&type=script&lang=js"
export * from "./factory_item_serviceArea.vue?vue&type=script&lang=js"
import style0 from "./factory_item_serviceArea.vue?vue&type=style&index=0&id=670c1047&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports